import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = ({ style }) => (
  <path
    style={style}
    d="M47,31c-2.76,9.02-10.54,15.59-19.9,16.79l-6.93-9.22L20,38.33l-1.3-1.73L18,35.67l-1-1.34l-1.27-1.69
L15.4,32.2l-1.1-1.46l-0.1-0.14L13,29l0.23-0.15l0.31-0.22L14,28.32l0.19-0.13l3.1-2.13l5.28-3.61l3.29-2.25L28,18.73l0,0l2.18-1.5
l0.73-0.5L32,16l0.67,0.67l1.17,1.17l0.66,0.66L47,31z"
  />
);

const SootSpriteAvatarArtwork = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.AVATAR_4}
    renderShadow={renderShadow}
  >
    <>
      <path
        style={{ fill: '#333333' }}
        d="M34.92,24.08C36.6,30,30,35,24,35s-12.6-5.88-10.92-10.92C15,18.36,18,14,24,14S33.26,18.28,34.92,24.08z"
      />
      <ellipse
        transform="matrix(0.5642 -0.8256 0.8256 0.5642 -10.2974 25.4879)"
        style={{ fill: '#FFFFFF' }}
        cx="19"
        cy="22.5"
        rx="3.98"
        ry="3.41"
      />
      <ellipse
        transform="matrix(0.8256 -0.5642 0.5642 0.8256 -7.6345 20.2847)"
        style={{ fill: '#FFFFFF' }}
        cx="29"
        cy="22.49"
        rx="3.41"
        ry="3.98"
      />
      <circle style={{ fill: '#333333' }} cx="19" cy="22" r="1" />
      <circle style={{ fill: '#333333' }} cx="29" cy="22" r="1" />
      <path
        style={{ fill: '#333333' }}
        d="M23,34.28C24.55,38,25,39,25,39l0.81-5L23,34.28z"
      />
      <polygon style={{ fill: '#333333' }} points="25,34 28,39 28,34 " />
      <polygon style={{ fill: '#333333' }} points="27,34 31,39 30,33 " />
      <polygon style={{ fill: '#333333' }} points="29,33 33,37 32,32 " />
      <polygon style={{ fill: '#333333' }} points="31,32 35,35 32.5,30 " />
      <polygon style={{ fill: '#333333' }} points="31,30 37,34 33.67,29 " />
      <polygon style={{ fill: '#333333' }} points="32,29 38,32 33.33,27 " />
      <polygon style={{ fill: '#333333' }} points="33,30 39,28 34,26 " />
      <polygon style={{ fill: '#333333' }} points="34,28 39,25 34,24 34,26 " />
      <polygon
        style={{ fill: '#333333' }}
        points="34,25 39,23 33,22 33.5,23.5 "
      />
      <polygon style={{ fill: '#333333' }} points="34,23 39,20 33,21 " />
      <polygon style={{ fill: '#333333' }} points="33,22 37,18 32,19 " />
      <polygon style={{ fill: '#333333' }} points="32,19.4 36,16 31,17 " />
      <polygon style={{ fill: '#333333' }} points="31,18 34,14 29,16 " />
      <polygon style={{ fill: '#333333' }} points="29,17 32,12 27,15 " />
      <polygon style={{ fill: '#333333' }} points="27.67,16 30,11 25,15 " />
      <polygon style={{ fill: '#333333' }} points="26,15 27,10 23,15 " />
      <polygon
        style={{ fill: '#333333' }}
        points="24,15 23,10 21,15 22.5,15 "
      />
      <polygon style={{ fill: '#333333' }} points="22,15 20,11 19,16 " />
      <polygon
        style={{ fill: '#333333' }}
        points="20,16 17,12 17,17.29 17.95,16.88 "
      />
      <polygon
        style={{ fill: '#333333' }}
        points="18,17 14,14 16,19 16.8,18.2 "
      />
      <polygon style={{ fill: '#333333' }} points="11,17 15,20.09 17,18 " />
      <polygon style={{ fill: '#333333' }} points="15,20 10,19 14.09,22 " />
      <polygon
        style={{ fill: '#333333' }}
        points="15,22 9,21 13,24.25 13.67,25 "
      />
      <polygon style={{ fill: '#333333' }} points="14,24 9,25 14,27 " />
      <polygon style={{ fill: '#333333' }} points="14,26 9,28 14,29 " />
      <polygon style={{ fill: '#333333' }} points="14,28 10,32 16,30 " />
      <polygon style={{ fill: '#333333' }} points="15,29 13,34 17,31 " />
      <polygon style={{ fill: '#333333' }} points="16,31 15,37 18,33 " />
      <polygon style={{ fill: '#333333' }} points="18,32 18,38 20,34 " />
      <polygon style={{ fill: '#333333' }} points="20,33 20,39 22,34 " />
      <polygon style={{ fill: '#333333' }} points="21,34 23,39 23.57,34.22 " />
    </>
  </AvatarArtwork>
);
export default SootSpriteAvatarArtwork;
